import { defaultAppImage, defaultAppImageColor } from "types";


export const getDefaultAppSvg =  () => {
    return defaultAppImage.replace(defaultAppImageColor, getRandomColor());
}

const getRandomColor = () => {
  return '#' + Math.random().toString(16).substring(4);
}